import { FC } from "react";

interface OutputProps {
  label: string;
  id: string;
  htmlFor?: string;
  value: string | number;
}

export const Output: FC<OutputProps> = ({ label, id, htmlFor, value }) => {
  return (
    <div className="flex flex-col">
      <label
        className="text-body-xs text-swdc-gray-400 pb-2 font-bold"
        htmlFor={id}
      >
        {label}
      </label>
      <output
        className="border-swdc-gray-400 bg-swdc-gray-50 text-link-s text-swdc-gray-400 rounded-button flex h-10 w-full items-center border-2 px-4 font-bold md:w-48"
        id={id}
        htmlFor={htmlFor}
      >
        {value}
      </output>
    </div>
  );
};
